import {
  Button,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  TextField,
} from "@mui/material";
import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import BottomDoctors from "../../assets/images/bottom-doctors.png";
import { useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";

function LoginPage() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  function handleSubmit() {}

  const handleLogin = () => {
    navigate("/dashboard/");
  };

  const buttonStyle = {
    height: "56px",
    borderRadius: "8px!important",
    paddings: "16px 24px 16px 24px!important",
    background: "#1E87FF",
    color: "#FFFFFF",
    fontFamily: "inter",
    fontSize: "14px",
  };

  return (
    <div className="flex min-h-[calc(100vh-88px)] flex-col relative">
      <div className="flex justify-center flex-col w-full">
        <p className="flex text-lg font-bold justify-center">
          Sign in to continue{" "}
        </p>
        <p className="flex mt-1 text-[#292727] justify-center text-center">
          Welcome to Care in Touch HR Onboarding platform{" "}
        </p>
        <form
          className="flex flex-col p-4 md:mx-auto mt-4 md:mt-8"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col gap-2 mb-4 md:w-[700px]">
            <InputLabel className="mt-1 text-[#292727] font-bold">
              Login
            </InputLabel>
            <TextField id="outlined-basic" variant="outlined" />
          </div>

          <div className="flex flex-col gap-2 mb-8">
            <InputLabel className="mt-1 text-[#292727] font-bold">
              Password
            </InputLabel>

            <OutlinedInput
              id="outlined-adornment-password"
              type={showPassword ? "text" : "password"}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </div>

          <Button
            variant="contained"
            onClick={handleLogin}
            sx={{ ...buttonStyle, textTransform: "none" }}
          >
            Sign in
          </Button>

          <div className="flex justify-between items-center mt-4">
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Remember me"
              />
            </FormGroup>

            <div className="text-[#1E87FF] font-bold">Forgot Password</div>
          </div>
        </form>
      </div>

      <div className="flex items-center mt-[auto] ">
        <img
          src={BottomDoctors}
          alt="doctors"
          className="max-w-[500px] hidden md:block"
        />
      </div>

      <p className="text-center mb-4 md:mb-0 md:absolute text-black lg:text-[#98A2B3]  bottom-3 font-bold w-full">
        2023 CIT, All rights reserved
      </p>
    </div>
  );
}

export default LoginPage;
